/**
 * What follows `base` in `pathname`, as `/a/b` for `/old/a/b/` under `old`, or an empty string when
 * nothing does. The match is case-insensitive because react-router's is: `/Browse/funds` reaches
 * the same redirect as `/browse/funds`, and has to keep its tail the same way.
 */
export function pathAfter(pathname: string, base: string): string {
  const prefix = `/${base.replace(/^\/+|\/+$/g, '')}`;
  if (!pathname.toLowerCase().startsWith(prefix.toLowerCase())) return '';
  const rest = pathname.slice(prefix.length).replace(/\/+$/, '');
  // `/browse-other` starts with `/browse` too, but is not under it.
  return rest.startsWith('/') ? rest : '';
}
